import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './components/i18n';
import {Route, HashRouter, BrowserRouter} from "react-router-dom";
import Header from "./components/Header";
import RequestsPage from "./components/RequestsPage";
import withRoot from "./withRoot";
import {LoginPage} from "./components/Login";
import {GlobalStateProvider, useCurrentState} from "./globalState";
import UserPage from "./components/UserPage";
import IndexPage from "./components/IndexPage";
import "./style.css";
import ConsecutiveSnackbars from "./components/ConsecutiveSnackbars";
import ConfirmationDialogs from "./components/ConfirmationDialogs";
import IdentitiesPage from "./components/IdentitiesPage";
import LogoutPage from "./components/LogoutPage";
import {withTranslation} from "react-i18next";
import CircularIndeterminate from "./components/CircularLoader";
import AccessTokensPage from "./components/AccessTokensPage";
import $ from "jquery";
import RequestPage from "./components/request/RequestPage";
import DebugTimelinePage from "./components/DebugTimelinePage";
import AdminPage from "./components/AdminPage";

if (window.Promise && !window.Promise.prototype.finally) {
    let promiseFinally = require('promise.prototype.finally');
    promiseFinally.shim();
}

function IndexWrapper(props) {
    return <React.Fragment>{props.children}</React.Fragment>
}


$(window).on("beforeunload", function (e) {
    // Your message won't get displayed by modern browsers; the browser's built-in
    // one will be instead. But for older browsers, best to include an actual
    // message instead of just "x" or similar.
    if (window.formDirty && window.location.href.indexOf('http://localhost') === -1) {
        e.originalEvent.returnValue = window.formDirty;
    }
});

let Themeable = withRoot(IndexWrapper);

function Index() {
    return <GlobalStateProvider><BrowserRouter>
        <Themeable>
            <div className="App">
                <Header/>
                <div className={'layout'}>
                    <div id={'layoutWrapper'}>
                        <Route exact={true} path="/requests" component={RequestsPage}/>
                        <Route path="/sign-request/:id" component={RequestPage}/>
                        <Route path="/debug/sign-request/:id" component={DebugTimelinePage}/>
                        <Route path="/request/:action/:signer_id" component={RequestPage}/>
                        <Route path="/identities" component={IdentitiesPage}/>
                        <Route path="/login" component={LoginPage}/>
                        <Route path="/user" component={UserPage}/>
                        <Route path="/logout" component={LogoutPage}/>
                        <Route path="/access_tokens" component={AccessTokensPage}/>
                        <Route path="/admin" component={AdminPage}/>
                        <Route exact={true} path="/" component={RequestsPage}/>
                    </div>
                </div>
                <ConfirmationDialogs/>
                <ConsecutiveSnackbars/>
            </div>
        </Themeable>
    </BrowserRouter></GlobalStateProvider>;
}

let TranslateableIndex = withTranslation()(Index);


function Load() {
    return <Suspense fallback={<CircularIndeterminate/>}>
        <TranslateableIndex/>
    </Suspense>;
}

ReactDOM.render(<Load/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
